// siteKey: '6LdB8qgUAAAAAHKGs8UPE_UO2NTunloaeVpNL73_', <- Antigo
export const environment = {
  production: true,
  siteKey: '6Le3SqEhAAAAAADfGnyN7ZX6wRIP-TOL76YZQP-H'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts